import React from 'react'
import { BsInstagram } from 'react-icons/bs'
import { FaFacebookF, FaArtstation, FaLinkedinIn } from 'react-icons/fa'
import { BsGithub } from 'react-icons/bs'

function SocialMedia() {
    return (
        <div className='app__social'>
            <div>
                <a href="https://www.artstation.com/seifeddine" target="_blank">
                    <FaArtstation />
                </a>
            </div>
            <div>
                <a href="https://linkedin.com/in/seifeddine-el-behi" target="_blank">
                    <FaLinkedinIn />
                </a>
            </div>
            <div>
                <a href="https://github.com/seifeddineelbehi" target="_blank">
                    <BsGithub />
                </a>
            </div>
        </div>
    )
}

export default SocialMedia